import React, { useState, useEffect } from 'react';

const C = { navy:'#001f3a', orange:'#f07820', orangeDk:'#9a4600', light:'#f8f9ff', white:'#ffffff' };

const Estrellas = ({ n }) => n ? (
  <div style={{ display:'flex', gap:'2px', marginBottom:'10px' }}>
    {[1,2,3,4,5].map(s => (
      <span key={s} style={{ color:s <= n ? C.orange : 'rgba(0,31,58,.15)', fontSize:'14px' }}>★</span>
    ))}
  </div>
) : null;

/**
 * Seccion de testimonios aprobados (via /api/testimonios).
 * Si aun no hay testimonios muestra solo la invitacion a dejar uno;
 * si la API falla no muestra nada para no romper la pagina.
 */
export default function Testimonios() {
  const [items, setItems] = useState(null);

  useEffect(() => {
    fetch('/api/testimonios')
      .then(r => r.ok ? r.json() : [])
      .then(data => setItems(Array.isArray(data) ? data : []))
      .catch(() => setItems([]));
  }, []);

  if (items === null) return null;

  return (
    <section style={{ padding:'64px 40px', background:C.white, borderTop:'1px solid rgba(0,31,58,.06)' }}>
      <div style={{ maxWidth:'1100px', margin:'0 auto' }}>
        <div style={{ textAlign:'center', marginBottom: items.length ? '40px' : '0' }}>
          <p style={{ fontSize:'11px', fontWeight:700, letterSpacing:'.12em', textTransform:'uppercase', color:C.orange, marginBottom:'12px' }}>TESTIMONIOS</p>
          <h2 className="d" style={{ fontSize:'clamp(1.6rem,3.5vw,2.2rem)', fontWeight:800, letterSpacing:'-.02em', color:C.navy, marginBottom:'10px' }}>Lo que dicen de HireMeUp</h2>
          <p style={{ fontSize:'14px', color:'rgba(0,31,58,.5)', marginBottom:'20px' }}>
            ¿HireMeUp te ayudó en tu camino? <a href="/feedback" style={{ color:C.orange, fontWeight:700 }}>Deja tu testimonio →</a>
          </p>
        </div>

        {items.length > 0 && (
          <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(300px,1fr))', gap:'16px' }}>
            {items.map((t, i) => (
              <div key={i} style={{ background:C.light, borderRadius:'16px', padding:'24px', border:'1px solid rgba(0,31,58,.06)', display:'flex', flexDirection:'column' }}>
                <Estrellas n={t.rating} />
                <p style={{ fontSize:'14px', lineHeight:1.7, color:'rgba(0,31,58,.7)', fontStyle:'italic', marginBottom:'16px' }}>"{t.texto}"</p>
                {/* el autor queda al pie para que las tarjetas de la fila se alineen */}
                <div style={{ display:'flex', alignItems:'center', gap:'10px', marginTop:'auto' }}>
                  <div style={{ width:'34px', height:'34px', borderRadius:'50%', background:`linear-gradient(135deg,${C.orange},${C.orangeDk})`, display:'flex', alignItems:'center', justifyContent:'center', color:'white', fontSize:'13px', fontWeight:700, flexShrink:0 }}>
                    {t.nombre.charAt(0).toUpperCase()}
                  </div>
                  <div>
                    <p className="d" style={{ fontWeight:700, fontSize:'13px', color:C.navy }}>{t.nombre}</p>
                    {(t.rol || t.pais) && (
                      <p style={{ fontSize:'11px', color:'rgba(0,31,58,.4)' }}>{[t.rol, t.pais].filter(Boolean).join(' · ')}</p>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
